import React from 'react';

export default function Toast({ message }) {
  if (!message) return null;

  // Determine color based on message content
  let alertClass = 'alert-info';
  if (message.includes('✓') || message.toLowerCase().includes('success')) {
    alertClass = 'alert-success';
  } else if (message.includes('✗') || message.toLowerCase().includes('fail') || message.toLowerCase().includes('error')) {
    alertClass = 'alert-danger';
  } else if (message.includes('⚠') || message.toLowerCase().includes('queue')) {
    alertClass = 'alert-warning';
  }

  return (
    <div
      className={`alert ${alertClass} py-2`}
      style={{ 
        position: 'fixed', 
        top: '80px', 
        right: '20px',
        zIndex: 9999, 
        minWidth: '300px',
        maxWidth: '500px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        animation: 'slideIn 0.3s ease-out',
        borderRadius: 6 
      }}
    >
      {message}
      <style>{`
        @keyframes slideIn {
          from {
            transform: translateX(400px);
            opacity: 0;
          }
          to {
            transform: translateX(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
}